import { getHttpClient } from "@/http-client";

const baseURL = "api/boss/reference";

// returns an array of strings
export async function getProductSolves() {
  const { data } = await getHttpClient().get(`${baseURL}/solves`);
  data.sort((a, b) => a.localeCompare(b));
  return data;
}

export async function getPermittedDocumentExtensions() {
  const { data } = await getHttpClient().get(`${baseURL}/allowed-upload-types`);

  return {
    extensions: data.extensions,
    pdf_mergable_extensions: data.pdf_mergable_extensions,
    carrier_status_file: data.carrier_status_file,
    form_mapping_form: data.form_mapping_form,
    help_center_image: data.help_center_image,
    statement: data.statement,
    statement_optional_pdf: data.statement_optional_pdf,
    avatar: data.avatar,
    pdf_unlock: data.pdf_unlock
  };
}
